import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { IMG } from "../../data/assets";
import { lineReveal } from "../../lib/motion";
import { useLanguage } from "../../lib/i18n";

export const Hero = () => {
  const navigate = useNavigate();
  const { t } = useLanguage();

  return (
    <section id="hero" data-testid="hero-section" className="relative min-h-[100svh] w-full overflow-hidden flex items-center">
      <div className="absolute inset-0 z-0">
        <img src={IMG.heroTerrace} alt="Mediterranean courtyard dining terrace" className="photo-grade w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-r from-[#14180E] via-[#14180E]/80 to-[#14180E]/30" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#14180E] via-transparent to-[#14180E]/40" />
      </div>

      <div className="relative z-10 w-full max-w-[1600px] mx-auto px-5 md:px-10 pt-28 pb-16">
        <motion.p initial={{ opacity: 0, x: -16 }} animate={{ opacity: 1, x: 0 }} transition={{ duration: 0.9, delay: 0.3 }} className="font-mono uppercase tracking-[0.3em] text-[10px] sm:text-[11px] text-[--gold] mb-6">
          {t("hero.eyebrow")}
        </motion.p>

        <h1 className="font-display font-light tracking-tight leading-[0.98] text-[--text] text-4xl sm:text-5xl md:text-6xl lg:text-7xl max-w-4xl">
          {[t("hero.h1a"), t("hero.h1b"), "last"].map((line, i) => (
            <span key={i} className="line-mask">
              <motion.span custom={i} variants={lineReveal} initial="hidden" animate="visible" className="block">
                {i === 2 ? <>{t("hero.h1c")} <span className="italic text-[--gold]">{t("hero.h1d")}</span></> : line}
              </motion.span>
            </span>
          ))}
        </h1>

        <motion.p initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.9, delay: 1 }} className="mt-8 text-[--text-2] text-base md:text-lg leading-relaxed max-w-xl">
          {t("hero.sub")}
        </motion.p>
        <motion.p initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.9, delay: 1.1 }} className="mt-3 font-mono text-[11px] uppercase tracking-[0.18em] text-[--text-2]/90">
          {t("hero.badge")}
        </motion.p>

        <motion.div initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.9, delay: 1.25 }} className="mt-10 flex flex-col sm:flex-row gap-4">
          <button data-testid="hero-plan-btn" onClick={() => navigate("/request-a-quote")} className="inline-flex items-center justify-center px-8 py-4 rounded-full bg-[--gold] text-[#14180E] font-mono text-[11px] uppercase tracking-[0.16em] hover:bg-[--text] transition-colors duration-400">
            {t("hero.plan")}
          </button>
          <button data-testid="hero-menus-btn" onClick={() => navigate("/menus")} className="inline-flex items-center justify-center px-8 py-4 rounded-full border border-[--gold]/70 text-[--gold] font-mono text-[11px] uppercase tracking-[0.16em] hover:bg-[--gold] hover:text-[#14180E] transition-colors duration-400">
            {t("hero.menus")}
          </button>
        </motion.div>
      </div>
    </section>
  );
};
